// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════════
   Story 8.12 — Modale profil membre groupement (lecture seule)
   ═══════════════════════════════════════════════════════════════════ */

/* ── Backdrop ──────────────────────────────────────────────────────── */

.modal-profil-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

/* ── Conteneur principal ───────────────────────────────────────────── */

.modal-profil-membre {
  width: 90vw;
  max-width: 1200px;
  max-height: 85vh;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.modal-profil-membre .modal-close-btn {
  position: absolute;
  top: 1rem;
  right: 1.2rem;
  background: none;
  border: none;
  font-size: 2.2rem;
  color: #6b7280;
  cursor: pointer;
  line-height: 1;
  z-index: 10;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  transition:
    background-color 0.15s,
    color 0.15s;
}

.modal-profil-membre .modal-close-btn:hover {
  color: #1f2937;
  background-color: #f3f4f6;
}

/* ── Loading & Error ───────────────────────────────────────────────── */

.modal-profil-loading,
.modal-profil-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  gap: 1rem;
}

.modal-profil-loading .spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.modal-profil-loading p {
  color: #6b7280;
  font-size: 0.95rem;
}

.modal-profil-error p {
  color: #ef4444;
  font-size: 0.95rem;
  text-align: center;
}

/* ── En-tête profil ────────────────────────────────────────────────── */

.modal-profil-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 1.8rem 2rem 1.2rem;
  margin-bottom: 2rem;
}

.modal-profil-header-left {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  flex: 1 1;
  min-width: 0;
}

.modal-profil-logo {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  object-fit: contain;
  flex-shrink: 0;
}

.modal-profil-logo-placeholder {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 600;
  color: #9ca3af;
  flex-shrink: 0;
}

.modal-profil-identity {
  min-width: 0;
}

.modal-profil-identity h2 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.3rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal-profil-details {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 1.2rem;
  font-size: 0.85rem;
  color: #6b7280;
}

.modal-profil-header-right {
  flex-shrink: 0;
  min-width: 140px;
}

/* ── Onglets ───────────────────────────────────────────────────────── */

.modal-profil-tabs {
  padding: 0 2rem;
  border-bottom: 1px solid #e5e7eb;
}

/* ── Corps de la modale ────────────────────────────────────────────── */

.modal-profil-body {
  overflow-y: auto;
  padding: 1.5rem 2rem 2rem;
  flex: 1 1;
}

/* ═══════════════════════════════════════════════════════════════════
   Styles partagés pour les composants ReadOnly*
   ═══════════════════════════════════════════════════════════════════ */

.readonly-tab {
  font-size: 0.9rem;
  color: #374151;
}

/* Section avec titre */
.readonly-section {
  margin-bottom: 1.8rem;
}

.readonly-section:last-child {
  margin-bottom: 0;
}

.readonly-section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #595959;
  padding: 0.6rem 1rem;
  background: #f9fafb;
  border-radius: 6px;
  margin-bottom: 1rem;
  border-left: 3px solid #f97316;
}

/* Grilles */
.readonly-grid {
  display: grid;
  gap: 0.8rem 1.5rem;
  margin-bottom: 0.8rem;
}

.readonly-grid.three-cols {
  grid-template-columns: repeat(3, 1fr);
}

.readonly-grid.two-cols {
  grid-template-columns: repeat(2, 1fr);
}

/* Champ lecture seule */
.readonly-field {
  margin-bottom: 0.6rem;
}

.readonly-field label {
  display: block;
  font-size: 0.8rem;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 0.2rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.readonly-field p {
  margin: 0;
  font-size: 0.9rem;
  color: #1f2937;
  word-break: break-word;
}

/* Texte long (description) */
.readonly-text-block {
  white-space: pre-wrap;
  line-height: 1.5;
  background: #f9fafb;
  padding: 0.6rem 0.8rem;
  border-radius: 4px;
  border: 1px solid #f3f4f6;
  max-height: 200px;
  overflow-y: auto;
}

/* Paires CA / RH */
.readonly-grid-pairs {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.readonly-pair {
  display: grid;
  grid-template-columns: 80px 1fr 80px 1fr;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.8rem;
  background: #f9fafb;
  border-radius: 4px;
}

.pair-label {
  font-size: 0.8rem;
  font-weight: 500;
  color: #6b7280;
}

.pair-value {
  font-size: 0.9rem;
  color: #1f2937;
}

/* Hint */
.readonly-hint {
  font-size: 0.82rem;
  color: #9ca3af;
  margin: 0 0 0.8rem;
  font-style: italic;
}

/* Empty */
.readonly-empty {
  color: #9ca3af;
  font-style: italic;
  padding: 1rem 0;
}

/* ── Lots ──────────────────────────────────────────────────────────── */

.readonly-lots-list {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.readonly-lot-group {
  padding: 0.6rem 0.8rem;
  background: #f9fafb;
  border-radius: 6px;
  border: 1px solid #f3f4f6;
}

.readonly-lot-name {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.4rem;
  font-size: 0.9rem;
}

.readonly-badge-ac {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  color: #f97316;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  padding: 0.1rem 0.4rem;
  border-radius: 4px;
  margin-left: 0.5rem;
  vertical-align: middle;
}

.readonly-lot-depts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.readonly-dept-tag {
  font-size: 0.78rem;
  color: #4b5563;
  background: #e5e7eb;
  padding: 0.15rem 0.5rem;
  border-radius: 3px;
}

/* ── Documents ─────────────────────────────────────────────────────── */

.readonly-doc-status-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 1rem;
}

.readonly-doc-status-row {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.4rem 0.6rem;
  border-radius: 4px;
  background: #f9fafb;
}

.readonly-doc-status-badge {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  flex-shrink: 0;
}

.readonly-doc-status-badge.uploaded {
  background: #dcfce7;
  color: #16a34a;
}

.readonly-doc-status-badge.missing {
  background: #fef2f2;
  color: #ef4444;
}

.readonly-doc-status-label {
  flex: 1 1;
  font-size: 0.88rem;
  color: #374151;
}

.readonly-doc-status-required {
  font-size: 0.78rem;
  color: #9ca3af;
}

.readonly-doc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
}

.readonly-doc-table th {
  text-align: left;
  padding: 0.6rem 0.8rem;
  background: #f3f4f6;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  border-bottom: 1px solid #e5e7eb;
}

.readonly-doc-table td {
  padding: 0.6rem 0.8rem;
  border-bottom: 1px solid #f3f4f6;
  color: #374151;
}

.readonly-doc-notice {
  font-size: 0.8rem;
  color: #9ca3af;
  font-style: italic;
  margin-top: 0.8rem;
}

/* ── Références ────────────────────────────────────────────────────── */

.readonly-references-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.readonly-reference-card {
  padding: 1rem;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.readonly-reference-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.8rem;
}

.readonly-reference-header h4 {
  font-size: 0.95rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.readonly-ref-badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
}

.readonly-ref-badge.complete {
  background: #dcfce7;
  color: #16a34a;
}

.readonly-ref-badge.incomplete {
  background: #fef3c7;
  color: #d97706;
}

.readonly-photo-info {
  font-size: 0.82rem;
  color: #6b7280;
  font-style: italic;
}

/* ── Équipe ────────────────────────────────────────────────────────── */

.readonly-team-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
}

.readonly-team-table th {
  text-align: left;
  padding: 0.6rem 0.8rem;
  background: #f3f4f6;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  border-bottom: 1px solid #e5e7eb;
}

.readonly-team-table td {
  padding: 0.6rem 0.8rem;
  border-bottom: 1px solid #f3f4f6;
  color: #374151;
}

.readonly-role-badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
}

.readonly-role-badge.admin {
  background: #dbeafe;
  color: #2563eb;
}

.readonly-role-badge.member {
  background: #f3f4f6;
  color: #6b7280;
}

/* ── IBAN masqué ───────────────────────────────────────────────────── */

.readonly-iban-masked {
  font-family: "Courier New", monospace;
  letter-spacing: 1px;
  color: #6b7280 !important;
}

/* ── Responsive ────────────────────────────────────────────────────── */

@media (max-width: 768px) {
  .modal-profil-membre {
    width: 95vw;
    max-height: 90vh;
  }

  .modal-profil-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 1.2rem 1.5rem;
  }

  .modal-profil-header-left {
    flex-direction: column;
    align-items: flex-start;
  }

  .modal-profil-body {
    padding: 1rem 1.5rem;
  }

  .readonly-grid.three-cols {
    grid-template-columns: 1fr;
  }

  .readonly-grid.two-cols {
    grid-template-columns: 1fr;
  }

  .readonly-pair {
    grid-template-columns: 60px 1fr 60px 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/DetailCandidature/ModalProfilMembre.css"],"names":[],"mappings":"AAAA;;wEAEwE;;AAExE,yEAAyE;;AAEzE;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,yEAAyE;;AAEzE;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB;;eAEa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,yEAAyE;;AAEzE;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yEAAyE;;AAEzE;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA,yEAAyE;;AAEzE;EACE,gBAAgB;EAChB,yBAAyB;EACzB,SAAO;AACT;;AAEA;;wEAEwE;;AAExE;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,yEAAyE;;AAEzE;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yEAAyE;;AAEzE;EACE,qCAAqC;EACrC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,yEAAyE;;AAEzE;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wCAAwC;EAC1C;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════════════\n   Story 8.12 — Modale profil membre groupement (lecture seule)\n   ═══════════════════════════════════════════════════════════════════ */\n\n/* ── Backdrop ──────────────────────────────────────────────────────── */\n\n.modal-profil-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1100;\n}\n\n/* ── Conteneur principal ───────────────────────────────────────────── */\n\n.modal-profil-membre {\n  width: 90vw;\n  max-width: 1200px;\n  max-height: 85vh;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n}\n\n.modal-profil-membre .modal-close-btn {\n  position: absolute;\n  top: 1rem;\n  right: 1.2rem;\n  background: none;\n  border: none;\n  font-size: 2.2rem;\n  color: #6b7280;\n  cursor: pointer;\n  line-height: 1;\n  z-index: 10;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  transition:\n    background-color 0.15s,\n    color 0.15s;\n}\n\n.modal-profil-membre .modal-close-btn:hover {\n  color: #1f2937;\n  background-color: #f3f4f6;\n}\n\n/* ── Loading & Error ───────────────────────────────────────────────── */\n\n.modal-profil-loading,\n.modal-profil-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  gap: 1rem;\n}\n\n.modal-profil-loading .spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.modal-profil-loading p {\n  color: #6b7280;\n  font-size: 0.95rem;\n}\n\n.modal-profil-error p {\n  color: #ef4444;\n  font-size: 0.95rem;\n  text-align: center;\n}\n\n/* ── En-tête profil ────────────────────────────────────────────────── */\n\n.modal-profil-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  padding: 1.8rem 2rem 1.2rem;\n  margin-bottom: 2rem;\n}\n\n.modal-profil-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1.2rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.modal-profil-logo {\n  width: 56px;\n  height: 56px;\n  border-radius: 8px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.modal-profil-logo-placeholder {\n  width: 56px;\n  height: 56px;\n  border-radius: 8px;\n  background-color: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.6rem;\n  font-weight: 600;\n  color: #9ca3af;\n  flex-shrink: 0;\n}\n\n.modal-profil-identity {\n  min-width: 0;\n}\n\n.modal-profil-identity h2 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 0.3rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.modal-profil-details {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem 1.2rem;\n  font-size: 0.85rem;\n  color: #6b7280;\n}\n\n.modal-profil-header-right {\n  flex-shrink: 0;\n  min-width: 140px;\n}\n\n/* ── Onglets ───────────────────────────────────────────────────────── */\n\n.modal-profil-tabs {\n  padding: 0 2rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n/* ── Corps de la modale ────────────────────────────────────────────── */\n\n.modal-profil-body {\n  overflow-y: auto;\n  padding: 1.5rem 2rem 2rem;\n  flex: 1;\n}\n\n/* ═══════════════════════════════════════════════════════════════════\n   Styles partagés pour les composants ReadOnly*\n   ═══════════════════════════════════════════════════════════════════ */\n\n.readonly-tab {\n  font-size: 0.9rem;\n  color: #374151;\n}\n\n/* Section avec titre */\n.readonly-section {\n  margin-bottom: 1.8rem;\n}\n\n.readonly-section:last-child {\n  margin-bottom: 0;\n}\n\n.readonly-section-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #595959;\n  padding: 0.6rem 1rem;\n  background: #f9fafb;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n  border-left: 3px solid #f97316;\n}\n\n/* Grilles */\n.readonly-grid {\n  display: grid;\n  gap: 0.8rem 1.5rem;\n  margin-bottom: 0.8rem;\n}\n\n.readonly-grid.three-cols {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.readonly-grid.two-cols {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n/* Champ lecture seule */\n.readonly-field {\n  margin-bottom: 0.6rem;\n}\n\n.readonly-field label {\n  display: block;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #6b7280;\n  margin-bottom: 0.2rem;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.readonly-field p {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #1f2937;\n  word-break: break-word;\n}\n\n/* Texte long (description) */\n.readonly-text-block {\n  white-space: pre-wrap;\n  line-height: 1.5;\n  background: #f9fafb;\n  padding: 0.6rem 0.8rem;\n  border-radius: 4px;\n  border: 1px solid #f3f4f6;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n/* Paires CA / RH */\n.readonly-grid-pairs {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.readonly-pair {\n  display: grid;\n  grid-template-columns: 80px 1fr 80px 1fr;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.8rem;\n  background: #f9fafb;\n  border-radius: 4px;\n}\n\n.pair-label {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.pair-value {\n  font-size: 0.9rem;\n  color: #1f2937;\n}\n\n/* Hint */\n.readonly-hint {\n  font-size: 0.82rem;\n  color: #9ca3af;\n  margin: 0 0 0.8rem;\n  font-style: italic;\n}\n\n/* Empty */\n.readonly-empty {\n  color: #9ca3af;\n  font-style: italic;\n  padding: 1rem 0;\n}\n\n/* ── Lots ──────────────────────────────────────────────────────────── */\n\n.readonly-lots-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n.readonly-lot-group {\n  padding: 0.6rem 0.8rem;\n  background: #f9fafb;\n  border-radius: 6px;\n  border: 1px solid #f3f4f6;\n}\n\n.readonly-lot-name {\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0.4rem;\n  font-size: 0.9rem;\n}\n\n.readonly-badge-ac {\n  display: inline-block;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #f97316;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  padding: 0.1rem 0.4rem;\n  border-radius: 4px;\n  margin-left: 0.5rem;\n  vertical-align: middle;\n}\n\n.readonly-lot-depts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.readonly-dept-tag {\n  font-size: 0.78rem;\n  color: #4b5563;\n  background: #e5e7eb;\n  padding: 0.15rem 0.5rem;\n  border-radius: 3px;\n}\n\n/* ── Documents ─────────────────────────────────────────────────────── */\n\n.readonly-doc-status-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-bottom: 1rem;\n}\n\n.readonly-doc-status-row {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.4rem 0.6rem;\n  border-radius: 4px;\n  background: #f9fafb;\n}\n\n.readonly-doc-status-badge {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.readonly-doc-status-badge.uploaded {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.readonly-doc-status-badge.missing {\n  background: #fef2f2;\n  color: #ef4444;\n}\n\n.readonly-doc-status-label {\n  flex: 1;\n  font-size: 0.88rem;\n  color: #374151;\n}\n\n.readonly-doc-status-required {\n  font-size: 0.78rem;\n  color: #9ca3af;\n}\n\n.readonly-doc-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.88rem;\n}\n\n.readonly-doc-table th {\n  text-align: left;\n  padding: 0.6rem 0.8rem;\n  background: #f3f4f6;\n  color: #6b7280;\n  font-weight: 500;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.readonly-doc-table td {\n  padding: 0.6rem 0.8rem;\n  border-bottom: 1px solid #f3f4f6;\n  color: #374151;\n}\n\n.readonly-doc-notice {\n  font-size: 0.8rem;\n  color: #9ca3af;\n  font-style: italic;\n  margin-top: 0.8rem;\n}\n\n/* ── Références ────────────────────────────────────────────────────── */\n\n.readonly-references-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.readonly-reference-card {\n  padding: 1rem;\n  background: #f9fafb;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.readonly-reference-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.8rem;\n}\n\n.readonly-reference-header h4 {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.readonly-ref-badge {\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.2rem 0.6rem;\n  border-radius: 4px;\n}\n\n.readonly-ref-badge.complete {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.readonly-ref-badge.incomplete {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.readonly-photo-info {\n  font-size: 0.82rem;\n  color: #6b7280;\n  font-style: italic;\n}\n\n/* ── Équipe ────────────────────────────────────────────────────────── */\n\n.readonly-team-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.88rem;\n}\n\n.readonly-team-table th {\n  text-align: left;\n  padding: 0.6rem 0.8rem;\n  background: #f3f4f6;\n  color: #6b7280;\n  font-weight: 500;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.readonly-team-table td {\n  padding: 0.6rem 0.8rem;\n  border-bottom: 1px solid #f3f4f6;\n  color: #374151;\n}\n\n.readonly-role-badge {\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n}\n\n.readonly-role-badge.admin {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.readonly-role-badge.member {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n/* ── IBAN masqué ───────────────────────────────────────────────────── */\n\n.readonly-iban-masked {\n  font-family: \"Courier New\", monospace;\n  letter-spacing: 1px;\n  color: #6b7280 !important;\n}\n\n/* ── Responsive ────────────────────────────────────────────────────── */\n\n@media (max-width: 768px) {\n  .modal-profil-membre {\n    width: 95vw;\n    max-height: 90vh;\n  }\n\n  .modal-profil-header {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 1.2rem 1.5rem;\n  }\n\n  .modal-profil-header-left {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .modal-profil-body {\n    padding: 1rem 1.5rem;\n  }\n\n  .readonly-grid.three-cols {\n    grid-template-columns: 1fr;\n  }\n\n  .readonly-grid.two-cols {\n    grid-template-columns: 1fr;\n  }\n\n  .readonly-pair {\n    grid-template-columns: 60px 1fr 60px 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
